"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_browser_1 = require("@amplitude/analytics-browser");
const formatter_1 = __importDefault(require("./formatter"));
class Tracker {
    constructor(apiKey, userId) {
        this.apiKey = apiKey;
        this.userId = "";
        this.formatter = new formatter_1.default();
        try {
            if (userId !== null && userId !== undefined && userId != "") {
                (0, analytics_browser_1.init)(apiKey, userId);
            }
            else {
                (0, analytics_browser_1.init)(apiKey);
            }
            this.initialized = true;
        }
        catch (e) {
            console.log(e);
            this.initialized = false;
        }
        this.amplitudeIdentify = new analytics_browser_1.Identify();
    }
    getBaseProperties() {
        return {
            "referrer-url": document.referrer,
            "location-url": document.location.href,
        };
    }
    trackEvent(eventName, eventProps) {
        try {
            if (typeof eventProps != "undefined" && eventProps != null) {
                (0, analytics_browser_1.track)(eventName, eventProps);
                return;
            }
            (0, analytics_browser_1.track)(eventName);
        }
        catch (e) {
            console.log(e);
        }
    }
    trackSignupButtonClicked(signupButtonType) {
        const eventProperties = Object.assign(Object.assign({}, this.getBaseProperties()), { "signup-button-type": signupButtonType });
        this.trackEvent("signup-button-clicked", eventProperties);
    }
    trackSignupPricingPageViewed(planGroupId, planGroupName, experimentId) {
        const eventProperties = Object.assign(Object.assign({}, this.getBaseProperties()), {
            "displayed-plan-group-id": planGroupId,
            "displayed-plan-group-name": planGroupName,
            "displayed-plan-group-experiment-id": experimentId,
        });
        this.setUserProperty("plan-group-experiment-id", experimentId);
        this.trackEvent("signup-pricing-page-viewed", eventProperties);
    }
    setUserProperty(propertyName, propertyValue) {
        this.amplitudeIdentify.setOnce(propertyName, propertyValue);
        (0, analytics_browser_1.identify)(this.amplitudeIdentify);
    }
}
exports.default = Tracker;
